import {
  Flex,
  IconButton,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { Delete, Vertical } from "@root/assets";
import useCustomTheme from "@root/hooks/useCustomTheme";
import React from "react";
import { useTranslation } from "react-i18next";
import { ModalDelete } from "@root/components/modal-delete";

export const ChatDeleteMenu: React.FC<any> = ({
  deleteAll,
  onRemoveClick,
  onRenameClick,
  isDisabled,
  chat,
}) => {
  const { t } = useTranslation("common");
  const { isOpen, onOpen, onClose } = useDisclosure(); // Chakra UI modal control


  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onOpen();
  };

  const handleDelete = () => {
    onRemoveClick?.(chat); 
    onClose(); 
  };

  
  const { color } = useCustomTheme();

  return (
    <>
      <Menu>
        <MenuButton
          backgroundColor="transparent"
          as={IconButton}
          icon={<Vertical color="#676879" />}
          size="xs"
          aria-label="Options"
          onClick={(e) => e.stopPropagation()}
        />
        <MenuList border="none" boxShadow="lg">
          {/* Delete Button */}
          <MenuItem
            padding="10px"
            onClick={handleClick}
            height="50px"
            width={"200px"}
            marginLeft={"10px"}
            borderRadius={"8px"}
            isDisabled={isDisabled}
            _hover={{
              bg: "#E4EBF0", // Set hover background color
            }}
          >
            <Flex flexDirection="row" alignItems="center">
              <Delete color="#5C6670" />
              <Text fontSize="14px" fontWeight={500} ml="5px">
                {deleteAll ? t("chat.removeAllChats") : t("chat.removeChat")}
              </Text>
            </Flex>
          </MenuItem>

         
        </MenuList>
      </Menu>
      <ModalDelete
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={handleDelete}
        title={t("chat.deleteChat")}
        description={t("chat.areYouSure")}
        deleteButtonTitle={t("chat.deleteBtn")}
        cancelButtonTitle={t("chat.cancelBtn")}
      />
    </>
  );
};
